import {isValidLengthDocumentId, sanitizeString} from "../../../../../Apis/functions";

export const ALL_TIME_TO = new Date('2014-08-18T23:59:59');
export const DEFAULT_TIME = new Date('2014-08-18T00:00:00')

export const PIN_LENGTH = { MIN: 6, MAX: 10 };
export const CECO_LENGTH = { MIN: 4, MAX: 256 };
export const CECO_CODE_NAME = "cecoCode";

export const USER_DATA = {
    id: '',
    userTypeId: '',
    name: '',
    lastName: '',
    secondLastName: '',
    genderId: '',
    phoneNumber: '',
    statusId: '',
    email: '',
    password: '',
    pin: '',
    documentId: '',
    dob: null,
    isValid: function (){
        return this.name !== '' &&
            this.lastName !== '' &&
            (!this.id || (this.id && this.email !== '' &&
            this.email != null))
    }
}


export const CONTRACTOR_EMPLOYEE_DATA = {
    ...USER_DATA,
    contractorEmployeeStatusId: '',
    contractorId: null,
    deviceId: null,
    firebaseId: null,
    selfie: null,
    userId: null,
    toCreateUpdate: function (password, extraData) {
        return {
            contractorEmployeeStatusId: this.contractorEmployeeStatusId !== '' ? this.contractorEmployeeStatusId : null,
            contractorId: sessionStorage.getItem('contractorId'),
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            selfie: this.selfie,
            userId: this.userId,
            documentId: this.documentId,
            password: password || null,
            extraData: extraData
            ? {
                field1: sanitizeString(extraData.field1),
                field2: sanitizeString(extraData.field2),
                field3: sanitizeString(extraData.field3),
                field4: sanitizeString(extraData.field4),
                field5: sanitizeString(extraData.field5),
                field6: sanitizeString(extraData.field6),
                field7: sanitizeString(extraData.field7),
                field8: sanitizeString(extraData.field8),
                field9: sanitizeString(extraData.field9),
                field10: sanitizeString(extraData.field10),
                field11: sanitizeString(extraData.field11),
                field12: sanitizeString(extraData.field12),
                field13: sanitizeString(extraData.field13),
                field14: sanitizeString(extraData.field14),
                field15: sanitizeString(extraData.field15),
                id: extraData.id,
                userId: extraData.userId,
            }
            : null
        };
    },
    isValidEmployee: function (){
        return  this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId &&
            isValidLengthDocumentId(this.documentId);
    }
}

export const TABS_SUPPLIER_EMPLOYEE = {
    DETAILS: {
        INDEX: 0
    },
    OTHER_DETAILS: {
        INDEX: 1
    },
    PHOTO: {
        INDEX: 2
    },
    SUMMARY: {
        INDEX: 3
    }
}

export const SUPPLIER_EMPLOYEE_DATA = {
    ...USER_DATA,
    supplierEmployeeStatusId: null,
    selfie: null,
    supplierId: null,
    userId: null,
    toRegister: function (password, extraData) {
        return {
            supplierEmployeeStatusId: this.supplierEmployeeStatusId !== '' ? this.supplierEmployeeStatusId : null,
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            supplierId: this.supplierId !== null ? null : sessionStorage.getItem('providerId'),
            userId: this.userId,
            documentId: this.documentId,
            password: password || null,
            extraData: extraData
            ? {
                field1: sanitizeString(extraData.field1),
                field2: sanitizeString(extraData.field2),
                field3: sanitizeString(extraData.field3),
                field4: sanitizeString(extraData.field4),
                field5: sanitizeString(extraData.field5),
                field6: sanitizeString(extraData.field6),
                field7: sanitizeString(extraData.field7),
                field8: sanitizeString(extraData.field8),
                field9: sanitizeString(extraData.field9),
                field10: sanitizeString(extraData.field10),
                field11: sanitizeString(extraData.field11),
                field12: sanitizeString(extraData.field12),
                field13: sanitizeString(extraData.field13),
                field14: sanitizeString(extraData.field14),
                field15: sanitizeString(extraData.field15),
                id: extraData.id,
                userId: extraData.userId,
            }
            : null
        };
    },
    isValidEmployee: function (){
        return  this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId &&
            isValidLengthDocumentId(this.documentId);
    }
}

export const EMPLOYEE_DATA = {
    departmentId: '',
    employeeId: '',
    startDate: null,
    endDate: null,
    roleId: '',
    zoneId: '',
    contractStatusId: '',
    id: '',
    [CECO_CODE_NAME]: null,
    isValid: function (isPilgrimsValidation = false) {

        const validation =
            this.employeeId !== '' &&
            this.startDate !== null &&
            this.roleId !== '';

        if (isPilgrimsValidation) {
            return validation && (this.departmentId !== '' && this.departmentId !== null);
        }

        return validation;
    }
}

export const EXTRA_DATA = {
    field1: '',
    field2: '',
    field3: '',
    field4: '',
    field5: '',
    field6: '',
    field7: '',
    field8: '',
    field9: '',
    field10: '',
    field11: '',
    field12: '',
    field13: '',
    field14: '',
    field15: '',
}

export const HEADER_DATA = {
    header1: '',
    header2: '',
    header3: '',
    header4: '',
    header5: '',
    header6: '',
    header7: '',
    header8: '',
    header9: '',
    header10: '',
    header11: '',
    header12: '',
    header13: '',
    header14: '',
    header15: '',
}


export const DIGITAL_PERSON_DEVICE_MODEL = {
    UNKNOWN: 0,
    OPTICAL: 1,
    CAPACITIVE: 2,
    THERMAL: 3,
    PRESSURE: 4,
}

export const CUSTOMIZED_MODEL = {
    fromValue: null,
    toValue: null,
    allDays: false,
    allTime: false,
    checkedZones: [],
    dayArray: [],
    isValid: function () {
        if (!this.checkedZones || this.checkedZones.length === 0) return false;
        if (!this.dayArray || this.dayArray.length === 0) return false;
        return !(this.fromValue === null || this.toValue === null);
    },
    clear: function (){
        return {
            ...this,
            checkedZones: [],
            dayArray: [],
            allTime: false,
            allDays: false,
            fromValue: null,
            toValue: null
        };
    }
};

export const SERVICE ={
    PILGRIMS:3
}
